module.exports = __webpack_public_path__ + "static/media/success(25) (Custom).a9490193.png";